'use client';
import HookSvg from '@/assets/icons/hook.svg';
import { useTranslation } from '@/i18n/client';
import React, { lazy, Suspense, useEffect, useState } from 'react';
import styles from './benefitBar.module.scss';
import(/* webpackPrefetch: true */ './benefitDialog');

const BenefitDialog = lazy(() => import('./benefitDialog'));

// @ts-ignore
const BenefitBarClient = ({ mindList, title }) => {
  const { t } = useTranslation();
  title = title || t('benefitWrap.dialogTitle');

  const [isOpen, setIsOpen] = useState(false);

  const initMindTransition = () => {
    const container: HTMLElement | null = document.getElementById('jdi-header-scroll-benefit-wrap');
    // @ts-ignore
    const tags = Array.from(container.querySelectorAll('[class^="benefitBar_tag"]'));

    const firstClone = tags[0].cloneNode(true);
    // @ts-ignore
    container.appendChild(firstClone);

    let currentIndex = 0;

    function scrollTags() {
      currentIndex++;

      // @ts-ignore
      container.style.transition = 'transform 0.5s ease';
      // @ts-ignore
      container.style.transform = `translateY(${-currentIndex * tags[0].offsetHeight}px)`;

      if (currentIndex === tags.length) {
        setTimeout(() => {
          // @ts-ignore
          container.style.transition = 'none';
          // @ts-ignore
          container.style.transform = 'translateY(0)';
          currentIndex = 0;
        }, 500);
      }
    }

    return setInterval(scrollTags, 5000);
  };

  useEffect(() => {
    // @ts-ignore
    let intervalId;
    if (mindList && mindList.length > 2) {
      intervalId = initMindTransition();
    }

    return () => {
      // @ts-ignore
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [mindList]);

  // @ts-ignore
  const handleOpenServiceDialog = (mindObj) => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  // @ts-ignore
  const getBenefit = (mindObj) => {
    return (
      <div className={styles.tag} onClick={() => handleOpenServiceDialog(mindObj)}>
        <HookSvg />
        <div className={styles.txt}>
          <div className={`${styles.title} ${styles.boldWeight}`}>{mindObj.serviceTitle}</div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.tagWrap}>{mindList && mindList.length ? getBenefit(mindList[0]) : null}</div>
      <div className={styles.tagWrap}>
        <div className={styles.tagsWrap}>
          <div className={styles.tags} id='jdi-header-scroll-benefit-wrap'>
            {mindList && mindList.length > 1
              ? // @ts-ignore
                mindList
                  .slice(1)
                  .map((item: any) => (
                    <React.Fragment key={item.serviceTitle}>{getBenefit(item)}</React.Fragment>
                  ))
              : null}
          </div>
        </div>
      </div>
      {isOpen && (
        <Suspense fallback={null}>
          <BenefitDialog open={isOpen} title={title} mindList={mindList} closeFn={handleClose} />
        </Suspense>
      )}
    </>
  );
};

export default BenefitBarClient;
